import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { extend } from 'underscore';
import { t } from 'services/translation';
import Waiver from '../waiver';
import Questions from '../questions';
import './index.scss';

export default class CheckoutAdditionalInformation extends Component {
  static propTypes = {
    questionsProps: PropTypes.object.isRequired,
    waiverProps: PropTypes.object.isRequired,
    showQuestions: PropTypes.bool,
    showWaiver: PropTypes.bool,
    stepNo: PropTypes.number,
    isLiveBooking: PropTypes.bool,
  };

  static defaultProps = {
    showQuestions: false,
    showWaiver: false,
  };

  componentDidMount() {
    // scroll this step to top on mobile views
    window.scrollTo(0, 0);
  }

  questionsProps = () => {
    const questionsProps = extend(
      {},
      this.props.questionsProps,
      this.formProps()
    );
    questionsProps.renderBottomBorder = this.props.showWaiver;
    return questionsProps;
  };

  waiverProps = () => {
    const onChangeProps = this.props.onChange
      ? { onChange: this.props.onChange }
      : {};
    return extend({}, this.props.waiverProps, this.formProps(), onChangeProps);
  };

  formProps = () => {
    return {
      fields: this.props.fields,
      errors: this.props.errors,
    };
  };

  render() {
    const { showWaiver, isLiveBooking, stepNo, showQuestions } = this.props;
    const aboveAnotherSection = showWaiver;
    return (
      <div className="CheckoutSection CheckoutAdditionalInformation">
        <h2>
          {!isLiveBooking && <span className="step">{stepNo}</span>}
          {t('ADDITIONAL_INFORMATION')}
        </h2>
        {showQuestions && (
          <div
            className={`CheckoutQuestionsContainer ${
              aboveAnotherSection ? 'section' : ''
            }`}
          >
            <Questions {...this.questionsProps()} />
          </div>
        )}
        {showWaiver ? (
          <div className="CheckoutWaiverContainer">
            <Waiver {...this.waiverProps()} />
          </div>
        ) : null}
      </div>
    );
  }
}
